import React from 'react';

export const UnknownExplanationBlock: React.FC = () => (
  <span style={{ whiteSpace: 'pre' }}></span>
);
